import { Component, OnInit, ViewChild, Output, EventEmitter, Inject } from '@angular/core';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatChipList } from '@angular/material/chips';
import { MatDatepicker, yearsPerPage } from '@angular/material/datepicker';
import { CampaignsService } from 'src/app/pages/campaign-module/campaigns/campaigns.service';
import { QuantityPurchasedByDoctorService } from '../quantity-purchased-by-doctor.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { LanguageService, DialogService, HelperService } from 'src/app/services';
import { catchError, finalize, map, tap, takeUntil } from "rxjs/operators";
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { environment } from 'src/environments/environment';
import { MediaObserver } from '@angular/flex-layout';
import { of as observableOf, fromEvent } from 'rxjs';
import * as moment from 'moment';
import { Moment } from 'moment';
import * as _ from 'lodash';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMMM YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'esc-quantity-purchased-by-doctor-filter',
  templateUrl: './quantity-purchased-by-doctor-filter.component.html',
  styleUrls: ['./quantity-purchased-by-doctor-filter.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class QuantityPurchasedByDoctorFilterComponent implements  OnInit {
  @Output() generateReport = new EventEmitter();
  
  @ViewChild('chipsCampaign') chipsCampaign: MatChipList;
  @ViewChild('campaignAC') campaignACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) campaignACTr: MatAutocompleteTrigger;
  
  @ViewChild('chipsDistribution') chipsDistribution: MatChipList;
  @ViewChild('distributionAC') distributionACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) distributionACTr: MatAutocompleteTrigger;
  
  @ViewChild('chipsIslandGroup') chipsIslandGroup: MatChipList;
  @ViewChild('island_groupAC') islGrpACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) islGrpACTr: MatAutocompleteTrigger;
  
  @ViewChild('chipsArea') chipsArea: MatChipList;
  @ViewChild('areaAC') areaACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) areaACTr: MatAutocompleteTrigger;
  
  @ViewChild('chipsDistrict') chipsDistrict: MatChipList;
  @ViewChild('districtAC') districtACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) districtACTr: MatAutocompleteTrigger;
  
  @ViewChild('chipsCity') cityDistrict: MatChipList;
  @ViewChild('cityAC') cityACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) cityACTr: MatAutocompleteTrigger;

  @ViewChild('chipsGroupType') chipsGroupType: MatChipList;
  @ViewChild('groupTypeAC') groupTypeACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) groupTypeACTr: MatAutocompleteTrigger;
  
  @ViewChild('chipsTerritory') chipsTerritory: MatChipList;
  @ViewChild('territoryAC') territoryACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) territoryACTr: MatAutocompleteTrigger;

  constructor(
    @Inject(MAT_DIALOG_DATA) public initialFilters,
    private dialogRef: MatDialogRef<QuantityPurchasedByDoctorFilterComponent>,
    private fb: FormBuilder,
    public media: MediaObserver,
    public campSvc: CampaignsService,
    private service: QuantityPurchasedByDoctorService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    public helper: HelperService
  ) { }

  public defaultOption = {
    id: 0,
    code: "all",
    description: "All"
  };
  public loading = {
    campaign: false,
    distribution: false,
    island_group: false,
    area:  false,
    district: false,
    city: false,
    territory: false,
    error: false,
    groupType: false
  };

  island_groups = [];
  island_group_ids = []
  areas = [];
  area_ids = []
  districts = [];
  district_ids = [];
  cities = [];
  city_ids = []
  territories = [];
  campaigns = [];
  campaign_id;
  distributions = [];
  distribution_ids = [];
  groupTypes = [];

  filterOptions = {
    island_group: [],
    area: [],
    district: [],
    city: [],
    territory: [],
    campaign: [],
    distribution: [],
    groupType: []
  }

  multiSelect = {
    selectedCampaigns: [this.defaultOption],
    selectedDistributions: [this.defaultOption],
    selectedIslandGroups: [this.defaultOption],
    selectedAreas: [this.defaultOption],
    selectedDistricts: [this.defaultOption],
    selectedCities: [this.defaultOption],
    selectedTerritories: [this.defaultOption],
  };

  data;
  defaultStartDate = moment().startOf('month');
  defaultEndDate = moment().endOf('month');
  public filters;
  public formGroup: FormGroup;
  networkErrMsg = this.languageService.getTranslation("MESSAGE_ERROR_NETWORK_CONNECTION", {});
  tempFromMonth;
  tempToMonth;

  ngOnInit() {
    this.initForm();
    this.detectFormChanges();
  }

  initForm() {
    this.campaigns = this.initialFilters.campaigns;
    this.groupTypes = this.initialFilters.groupTypes;

    const selectedCampaign = this.campaigns.find(
      (campaign) => campaign.id === this.initialFilters.web_filter.campaign_id
    );
    const selectedGroupType = this.groupTypes.find(
      (groupType) =>
        groupType.id === this.initialFilters.web_filter.group_type_id
    );

    const initialFromMonth = moment().year(this.initialFilters.web_filter.from_year).month(this.initialFilters.web_filter.from_month - 1).startOf('month');
    const initialToMonth = moment().year(this.initialFilters.web_filter.to_year).month(this.initialFilters.web_filter.to_month - 1).endOf('month');
    const initialDistribution = this.initialFilters.web_filter.distribution_id;
    const initialIslandGroup = this.initialFilters.web_filter.island_group_id;
    const initialArea = this.initialFilters.web_filter.area_id;
    const initialDistrict = this.initialFilters.web_filter.district_id;
    const initialTerritory = this.initialFilters.web_filter.group_filter_id;

    this.formGroup = this.fb.group({
      fromMonth: [initialFromMonth || this.defaultStartDate, Validators.required],
      toMonth: [initialToMonth || this.defaultEndDate, Validators.required],
      campaign: [selectedCampaign || 0, Validators.required],
      distribution: [initialDistribution || [0], Validators.required],
      island_group: [initialIslandGroup || [0], Validators.required],
      area: [initialArea || [0], Validators.required],
      district: [initialDistrict || [0], Validators.required],
      city: [_.get(this.data, 'city') || [0]],
      territory: [initialTerritory || [0], Validators.required],
      groupType: [selectedGroupType || [0], Validators.required],
    })

    this.tempToMonth = _.cloneDeep(new Date(moment(_.get(this.data, 'toMonth')).toDate()));
    this.tempFromMonth = _.cloneDeep(new Date(moment(_.get(this.data, 'fromMonth')).toDate()));
  }

  chosenYearHandler(normalizedYear: Moment, selectedDate) {
    const ctrlValue = this.formGroup.get(selectedDate).value;
    ctrlValue.year(normalizedYear.year());
    this.formGroup.get(selectedDate).setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, selectedDate) {
    const ctrlValue = this.formGroup.get(selectedDate).value;
    ctrlValue.month(normalizedMonth.month());
    this.formGroup.get(selectedDate).setValue(ctrlValue);
    if(selectedDate == 'fromMonth') {
      this.tempFromMonth = new Date ((moment(this.formGroup.get(selectedDate).value)).toDate());
    } else if(selectedDate == 'toMonth') {
      this.tempToMonth = new Date ((moment(this.formGroup.get(selectedDate).value)).toDate());
    }
    datepicker.close();
  }

  detectFormChanges() {
    this.formGroup.get('campaign').valueChanges.subscribe(value => {
      if(value) {
        this.formGroup.get('distribution').setValue(this.defaultOption, { emitEvent: false })
        this.formGroup.get('island_group').setValue(this.defaultOption, { emitEvent: false })
        this.formGroup.get('area').setValue(this.defaultOption, { emitEvent: false })
        this.formGroup.get('district').setValue(this.defaultOption, { emitEvent: false })
        this.formGroup.get('city').setValue(this.defaultOption, { emitEvent: false })
        this.formGroup.get('territory').setValue(this.defaultOption, { emitEvent: false })
        this.formGroup.get('groupType').setValue(null, { emitEvent: false })
      }

      for(let prop in this.multiSelect) {
        // console.log(prop);
        this.multiSelect[prop] = [this.defaultOption];
      }
    })
  }

  getInitialData(name) {
    this.autoCmpltClosed(name);
    this.filters = _.cloneDeep(INITIAL_OPTIONS);
    this.getData(name);
  }
 
  getMoreData(name) {
    if (this.filters.getMore) {
      this.filters.web_filter.offset += INITIAL_OPTIONS.web_filter.limit;
      this.getData(name);
    }
  }
 
  handleFilterResponse(res,filterName,filters, selectedArrayGroup){
    this.loading[filterName] = false;
    if (environment.showLogs) {
      console.log(res);
    }
    if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
      this.loading.error = true;
      this.dialogService.openSnackBar(this.networkErrMsg)
      return;
    }
    if (_.has(res, 'value') && (res.value == "Success")) {
      if (!filters.web_filter.keyword) {
        this.filterOptions[filterName][0] = this.defaultOption;
      }

      this.filterOptions[filterName] = this.filterOptions[filterName].concat(res.data);
      this.checkSelected(filterName, selectedArrayGroup, filterName);

      if ((res.data.length > 0) && (this.filterOptions[filterName].length < _.get(res, 'count'))) {
        this.filters.getMore = true;
      }
    }
  }
  
  getData(name) {
    let filters = _.cloneDeep(this.filters)
    this.filters.getMore = false;
    this.loading[name] = true;

    switch (name) {
      case "campaign": {
        this.campaigns = []
        filters.web_filter["filter_type"] = "campaign"
        filters.web_filter.filters["from_month"] = moment(this.formGroup.get("fromMonth").value).format("M")
        filters.web_filter.filters["to_month"] = moment(this.formGroup.get("toMonth").value).format("M")
        filters.web_filter.filters["from_year"] = moment(this.formGroup.get("fromMonth").value).format("YYYY")
        filters.web_filter.filters["to_year"] = moment(this.formGroup.get("toMonth").value).format("YYYY")
        filters.web_filter.filters["campaign_id"] = 0
        filters.web_filter.filters["distribution_id"] = [0]
        filters.web_filter.filters["island_group_id"] =  [0]
        filters.web_filter.filters["area_id"] = [0]
        filters.web_filter.filters["district_id"] = [0]
        filters.web_filter.filters["territory_id"] =  [0]
        filters.web_filter.filters["group_type_id"] =  0
        this.service.filter(filters).pipe(
          tap(() => this.loading.campaign = true),
          finalize(() => {
            this.loading.campaign = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.campaign = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.campaign = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.loading.error = true;
              this.filterOptions['campaign'] = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              this.filterOptions['campaign'] = this.filterOptions['campaign'].concat(res.data);
             for(var camp of this.campaigns){
                this.campaign_id = camp.id
             }
              if((res.data.length > 0) && (this.distributions.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
      case "distribution":{
        this.distributions = []
        filters.web_filter["filter_type"] = "distribution"
        filters.web_filter.filters["from_month"] = moment(this.formGroup.get("fromMonth").value).format("M")
        filters.web_filter.filters["to_month"] = moment(this.formGroup.get("toMonth").value).format("M")
        filters.web_filter.filters["from_year"] = moment(this.formGroup.get("fromMonth").value).format("YYYY")
        filters.web_filter.filters["to_year"] = moment(this.formGroup.get("toMonth").value).format("YYYY")
        filters.web_filter.filters["campaign_id"] = this.formGroup.get("campaign").value["id"]
        filters.web_filter.filters["distribution_id"] = [0]
        filters.web_filter.filters["island_group_id"] =  [0]
        filters.web_filter.filters["area_id"] = [0]
        filters.web_filter.filters["district_id"] = [0]
        filters.web_filter.filters["territory_id"] =  [0]
        filters.web_filter.filters["group_type_id"] =  0
        this.service.filter(filters).pipe(
          tap(() => this.loading.island_group = true),
          finalize(() => {
            this.loading.island_group = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.distribution = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'distribution',filters,'selectedDistributions')
          });
          break;
      }
      case "island_group":{
        this.island_groups = []
        filters.web_filter["filter_type"] = "island_group"
        filters.web_filter.filters["from_month"] = moment(this.formGroup.get("fromMonth").value).format("M")
        filters.web_filter.filters["to_month"] = moment(this.formGroup.get("toMonth").value).format("M")
        filters.web_filter.filters["from_year"] = moment(this.formGroup.get("fromMonth").value).format("YYYY")
        filters.web_filter.filters["to_year"] = moment(this.formGroup.get("toMonth").value).format("YYYY")
        filters.web_filter.filters["campaign_id"] = this.formGroup.get("campaign").value["id"] || 0
        filters.web_filter.filters["distribution_id"] = this.helper.reportFilterGet(this.formGroup.get("distribution").value, [0]) 
        filters.web_filter.filters["island_group_id"] =  [0]
        filters.web_filter.filters["area_id"] = [0]
        filters.web_filter.filters["district_id"] = [0]
        filters.web_filter.filters["territory_id"] =  [0]
        filters.web_filter.filters["group_type_id"] =  0
        this.service.filter(filters).pipe(
          tap(() => this.loading.island_group = true),
          finalize(() => {
            this.loading.island_group = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.island_group = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'island_group',filters,'selectedIslandGroups')
          });
          break;
      }
      case "area":{
        this.areas = [];
        filters.web_filter["filter_type"] = "area";
        filters.web_filter.filters["from_month"] = moment(this.formGroup.get("fromMonth").value).format("M");
        filters.web_filter.filters["to_month"] = moment(this.formGroup.get("toMonth").value).format("M");
        filters.web_filter.filters["from_year"] = moment(this.formGroup.get("fromMonth").value).format("YYYY");
        filters.web_filter.filters["to_year"] = moment(this.formGroup.get("toMonth").value).format("YYYY");
        filters.web_filter.filters["campaign_id"] = this.formGroup.get("campaign").value["id"] || 0
        filters.web_filter.filters["distribution_id"] = this.helper.reportFilterGet(this.formGroup.get("distribution").value, [0]);
        filters.web_filter.filters["island_group_id"] =  this.helper.reportFilterGet(this.formGroup.get("island_group").value, [0]);
        filters.web_filter.filters["area_id"] = [0];
        filters.web_filter.filters["district_id"] = [0];
        filters.web_filter.filters["territory_id"] =  [0];
        filters.web_filter.filters["group_type_id"] =  0;
        this.service.filter(filters).pipe(
          tap(() => this.loading.area = true),
          finalize(() => {
            this.loading.area = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.area = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'area',filters,'selectedAreas')
          });
          break;
      }
      case "district":{
        this.districts = [];
        filters.web_filter["filter_type"] = "district";
        filters.web_filter.filters["from_month"] = moment(this.formGroup.get("fromMonth").value).format("M");
        filters.web_filter.filters["to_month"] = moment(this.formGroup.get("toMonth").value).format("M");
        filters.web_filter.filters["from_year"] = moment(this.formGroup.get("fromMonth").value).format("YYYY");
        filters.web_filter.filters["to_year"] = moment(this.formGroup.get("toMonth").value).format("YYYY");
        filters.web_filter.filters["campaign_id"] = this.formGroup.get("campaign").value["id"] || 0;
        filters.web_filter.filters["distribution_id"] = this.helper.reportFilterGet(this.formGroup.get("distribution").value, [0]);
        filters.web_filter.filters["island_group_id"] =  this.helper.reportFilterGet(this.formGroup.get("island_group").value, [0]);
        filters.web_filter.filters["area_id"] = this.helper.reportFilterGet(this.formGroup.get("area").value, [0]);
        filters.web_filter.filters["district_id"] = [0];
        filters.web_filter.filters["group_type_id"] = 0;
        this.service.filter(filters).pipe(
          tap(() => this.loading.district = true),
          finalize(() => {
            this.loading.district = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.district = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'district',filters,'selectedDistricts')
          });
          break;
      }

      case "groupType":{
        this.groupTypes = [];
        filters.web_filter["filter_type"] = "group_type";
        filters.web_filter.filters["from_month"] = moment(this.formGroup.get("fromMonth").value).format("M");
        filters.web_filter.filters["to_month"] = moment(this.formGroup.get("toMonth").value).format("M");
        filters.web_filter.filters["from_year"] = moment(this.formGroup.get("fromMonth").value).format("YYYY");
        filters.web_filter.filters["to_year"] = moment(this.formGroup.get("toMonth").value).format("YYYY");
        filters.web_filter.filters["campaign_id"] = this.formGroup.get("campaign").value["id"] || 0;
        filters.web_filter.filters["distribution_id"] = this.helper.reportFilterGet(this.formGroup.get("distribution").value, [0]);
        filters.web_filter.filters["island_group_id"] =  this.helper.reportFilterGet(this.formGroup.get("island_group").value, [0]);
        filters.web_filter.filters["area_id"] = this.helper.reportFilterGet(this.formGroup.get("area").value, [0]);
        filters.web_filter.filters["district_id"] = this.helper.reportFilterGet(this.formGroup.get("district").value, [0]);
        filters.web_filter.filters["group_type_id"] = 0;
        this.service.filter(filters).pipe(
          tap(() => this.loading.groupType = true),
          finalize(() => {
            this.loading.groupType = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.groupType = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.groupType = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.loading.error = true;
              this.filterOptions['groupType'] = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              this.filterOptions['groupType'] = this.filterOptions['groupType'].concat(res.data);
             
              if((res.data.length > 0) && (this.filterOptions['groupType'].length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }

      case "territory":{
        this.territories = [];
        filters.web_filter["filter_type"] = "territory";
        filters.web_filter.filters["from_month"] = moment(this.formGroup.get("fromMonth").value).format("M");
        filters.web_filter.filters["to_month"] = moment(this.formGroup.get("toMonth").value).format("M");
        filters.web_filter.filters["from_year"] = moment(this.formGroup.get("fromMonth").value).format("YYYY");
        filters.web_filter.filters["to_year"] = moment(this.formGroup.get("toMonth").value).format("YYYY");
        filters.web_filter.filters["campaign_id"] = this.formGroup.get("campaign").value["id"] || 0;
        filters.web_filter.filters["distribution_id"] = this.helper.reportFilterGet(this.formGroup.get("distribution").value, [0]);
        filters.web_filter.filters["island_group_id"] =  this.helper.reportFilterGet(this.formGroup.get("island_group").value, [0]);
        filters.web_filter.filters["area_id"] = this.helper.reportFilterGet(this.formGroup.get("area").value, [0]);
        filters.web_filter.filters["district_id"] = this.helper.reportFilterGet(this.formGroup.get("district").value, [0]);
        filters.web_filter.filters["group_type_id"] = 0;
        this.service.filter(filters).pipe(
          tap(() => this.loading.territory = true),
          finalize(() => {
            this.loading.territory = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.territory = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'territory',filters,'selectedTerritories')
          });
          break;
      }
    }
  }
  
  autoCmpltClosed(name) {
    this.filterOptions[name] = [];
  }

  resetControl(control: FormControl) {
    control.reset(null, { emitEvent: false });
  }
 
  displayFn(data?: any): string | undefined {
    return data ? _.get(data, 'description') : null;
  }

  autocompleteScroll(name, refName, acTrigger) {
    setTimeout(() => {
      if (this[refName].isOpen || this[refName].panel) {
        fromEvent(this[refName].panel.nativeElement, 'scroll')
          .pipe(
            map(x => this[refName].panel.nativeElement.scrollTop),
            takeUntil(this[acTrigger].panelClosingActions)
          )
          .subscribe(x => {
            const scrollTop = this[refName].panel.nativeElement
              .scrollTop;
            const scrollHeight = this[refName].panel.nativeElement
              .scrollHeight;
            const elementHeight = this[refName].panel.nativeElement
              .clientHeight;
            const atBottom = scrollHeight === scrollTop + elementHeight;
            if (atBottom) {
              // fetch more data
              this.getMoreData(name);
            }
          });
      }
    });
  }

  applyFilters() {
    for (let ctrl in this.formGroup.controls) {
      if(!this.formGroup.controls[ctrl].valid) {
        this.formGroup.controls[ctrl].markAsTouched();
      }
    }
    if (this.formGroup.valid) {
      // this.generateReport.next(this.formGroup.value);
      this.dialogRef.close(this.formGroup.value);
    }
  }

  checkAutocompleteObject(control, objectKey, targetArray) {
    if ((!_.isObject(control.controls[objectKey].value) || control.controls[objectKey].value.id == null) && control.controls[objectKey].value != "") {
      control.controls[objectKey].setErrors({
        "notExisting": true
      });
    }

    if(_.size(this[targetArray]) && targetArray) {
      control.controls[objectKey].setValue(null);
      this.assignFormValues(targetArray, objectKey);
    }
  }

  optionClicked(event: Event, data, srcArray, targetArray, formControlName, inputElem) {
    event.stopPropagation();
    this.toggleSelection(data, srcArray, targetArray, formControlName, inputElem);
  }
 
  toggleSelection(data, srcArray, targetArray, formControlName, inputElem) {
    if (inputElem) {
      inputElem.value = '';
    }
    data.selected = !data.selected;

    //if 'all' is selected, choose only all
    if (data.selected == true && data.code == 'all') {
      srcArray.forEach(e => {
        e.selected = true;
      });
      this.multiSelect[targetArray] = [];
      this.multiSelect[targetArray].push(data);
      this.disableCheckbox(srcArray, formControlName, data);
    }

    //if 'all' is deselected, unselect everything
    else if (data.selected == false && data.code == 'all') {
      srcArray.forEach(e => {
        e.selected = false;
      });
      this.multiSelect[targetArray].splice(this.multiSelect[targetArray].indexOf(data), 1);
      this.enableCheckbox(srcArray);
    }

    else if (this.multiSelect[targetArray].indexOf(data) == -1) {
      //if other option is selected, check if 'all' is already selected and clear selection
      // this.multiSelect[targetArray].some(opt => opt.code == data.code)
      if (this.multiSelect[targetArray].indexOf(this.defaultOption) > -1) {
        srcArray.forEach(e => {
          e.selected = false;
        });
        this.multiSelect[targetArray] = [];
      }
      //if data exists in array, remove from list
      else if (this.multiSelect[targetArray].some(opt => opt.code == data.code)) {
        let index = _.findIndex(this.multiSelect[targetArray], function (item) { return item['code'] == data.code })
        this.multiSelect[targetArray].splice(index, 1);
      }
      else {
        this.multiSelect[targetArray].push(data);
      }
    }

    else {
      this.multiSelect[targetArray].splice(this.multiSelect[targetArray].indexOf(data), 1);
      srcArray.forEach(e => {
        if (e.id == data.id) {
          e.selected = false;
        }
      });
    }
    this.assignFormValues(targetArray, formControlName);
  }
 
  enableCheckbox(optionArray) {
    optionArray.forEach(e => {
      e.disabled = false;
    })
  }
 
  disableCheckbox(optionArray, formControlName, data) {
    if (optionArray[0].selected && (_.has(this.formGroup.get(formControlName), 'value') && this.formGroup.get(formControlName).value == 0) || (_.get(data, 'code') == 'all')) {
      optionArray.forEach(e => {
        if(e.code != 'all') {
          e.disabled = true;
        }
      })
    } else {
      this.enableCheckbox(optionArray);
    }
  }
 
  
  checkSelected(srcArray, targetArray, formControlName) {
    if (this.multiSelect[targetArray].some(opt => opt.description == 'All')) {
      let tempObj = _.cloneDeep(this.defaultOption);
      tempObj['selected'] = false;
      this.toggleSelection(tempObj, this.filterOptions[srcArray], targetArray, formControlName, null);
    }
    else if (this.multiSelect[targetArray].length) {
      this.filterOptions[srcArray].forEach(e => {
        this.multiSelect[targetArray].forEach(v => {
          if (e.description == v.description) {
            e.selected = v.selected;
          }
        })
        if (e.description == 'All') {
          e.selected = false;
        }
      })
    } else {
      this[srcArray].forEach(e => {
        e.selected = false;
      })
    }
  }
  
  assignFormValues(targetArray, formControlName) {
    let tempArr;
    if((formControlName != 'location_area') && (formControlName != 'location_district') && (formControlName != 'location_city')) {
      tempArr = this.multiSelect[targetArray].map(e => {
        return e.id;
      });
    } else {
      tempArr = this.multiSelect[targetArray].map(e => {
        let obj = {
          code: e.code,
          description: e.description
        }
        return obj;
      });
    }
    this.formGroup.get(formControlName).setValue(tempArr);
  }

  reset() {
    for(let ctrl in this.formGroup.controls) {
      this.formGroup.controls[ctrl].reset(null, {emitEvent: false});
      this.formGroup.controls[ctrl].setValue(null, {emitEvent: false});
      this.formGroup.controls[ctrl].markAsUntouched();
    }

    this.formGroup.get('fromMonth').setValue(this.defaultStartDate);
    this.formGroup.get('toMonth').setValue(this.defaultEndDate);
    this.formGroup.get('island_group').setValue(this.defaultOption);
    this.formGroup.get('area').setValue(this.defaultOption);
    this.formGroup.get('district').setValue(this.defaultOption);
    this.formGroup.get('city').setValue(this.defaultOption);
    this.formGroup.get('territory').setValue(this.defaultOption);
    this.formGroup.get('distribution').setValue(this.defaultOption);

    for(let prop in this.multiSelect) {
      // console.log(prop);
      this.multiSelect[prop] = [this.defaultOption];
    }
  }
}

const INITIAL_OPTIONS = {
  web_filter: {
    filter_type: "",
    filters: {
        from_month: 1,
        to_month: 12,
        from_year: 2020,
        to_year: 2020,
        campaign_id: 0,
        distribution_id: [0],
        island_group_id: [0],
        area_id: [0],
        district_id: [0],
        group_filter_id: [0],
        group_type_id: 0
    },
    limit: 50,
    offset: 0,
    keyword: ""
  }
}